import {computed, ref, watch} from "vue";
import useDebounce from "@/composables/useDebounce";

export default function (props, getListMethod, emit) {
    const list = ref([]);
    const query = ref('');
    const debounce = useDebounce();

    const model = computed({
        get: () => props.value,

        set(value) {
            emit('input', value)
        }
    });

    watch(() => props.value, (value) => {
        list.value = value ? [value] : [];
    })

    async function updateList(searchQuery) {
        query.value = searchQuery;

        if (query.value.length) {
            debounce(async () => {
                let {data} = await getListMethod(query.value)
                list.value = data;
            })
        }
    }

    return {
        model,
        list,
        query,
        updateList
    }
}
